import React, { useState } from 'react';
import { format } from 'date-fns';
import { IconButton } from '@material-ui/core';
import { Close, Edit } from '@material-ui/icons';

import { ApplicationEditForm } from '../ApplicationEditForm/ApplicationEditForm';
import { MaskedContent } from '../../MaskedContent';
import { applicationKeysMap } from '../const';
import { parseDate } from '../../../utils/date';

import cn from './ApplicationDetails.module.scss'

const dateFields =
  [
    'date_of_birth',
    'membership_date',
    'date_of_cancellation',
    'deceased_date',
    'date_of_claim',
    'contract_date',
  ];

export function ApplicationDetails({ application, editable, handleEdit, serviceAgencies, insuranceAgencies }) {
  const [isEdit, setIsEdit] = useState(false);

  const toggleEditMode = () => setIsEdit(!isEdit);
  const closeEditMode = () => setIsEdit(false);

  return (
    <div className={cn.applicationDetails}>
      {editable && (
        <IconButton onClick={toggleEditMode} className={cn.editButton}>
          {isEdit ? <Close /> : <Edit />}
        </IconButton>
      )}
      {isEdit ? (
        <ApplicationEditForm
          application={application}
          onClose={closeEditMode}
          onEdit={handleEdit}
          serviceAgencies={serviceAgencies}
          insuranceAgencies={insuranceAgencies}
        />
      ) : (
        <div>
          {Object.keys(applicationKeysMap)
            .filter((key) => application[key] !== undefined)
            .map((key) => {
              let value = application[key] || '-';
              if (application[key] && dateFields.includes(key)) {
                try {
                  value = format(parseDate(application[key]), 'MM/dd/yyyy');
                } catch (e) {
                  value = null;
                }
              }
              return (
                <div className={cn.row} key={key}>
                  <div className={cn.label}>{applicationKeysMap[key].label}:</div>
                  {applicationKeysMap[key].mask ? (
                    <MaskedContent content={value} className={cn.value} />
                  ) : (
                    <div className={cn.value}>{value}</div>
                  )}
                </div>
              )
            })
          }
        </div>
      )}
    </div>
  );
}
